module.exports = __webpack_public_path__ + "media/3.4dc51006.mp4";